<template lang="pug">
  v-app-bar.headernavbarsimple(app clipped-left)
    v-img.fill-height.headernavbarsimple__logo(src="@/assets/logo_emara3.png" alt="Emara play" position="left center" contain)
    v-spacer
    ButtonSelectLenaguage(:translations="$t('components.headerNabvar')")
</template>

<script>
  import ButtonSelectLenaguage from '@/components/buttons/ButtonSelectLenaguage';

  export default {
    name: "HeaderNabvarSimple",
    components: {
      ButtonSelectLenaguage
    }
  }
</script>

<style lang="sass">
.headernavbarsimple
  &__logo
    max-width: 150px
    min-width: 120px
    @media (min-width: 600px)
      max-width: 250px
  &__flag
    width: 24px
</style>

